(function () {
  'use strict';
  const KEY = 'pp_pdp_ab_20261019_v1';
  const TTL = 30 * 86400000;
  function valid(record, now) {
    return record && record.experiment === KEY && /^[AB]$/.test(record.variant) && typeof record.id === 'string' && record.expires > now;
  }
  function select(record, now, random, id) {
    return valid(record, now) ? record : {experiment:KEY, variant:random < 0.5 ? 'A' : 'B', id:id, expires:now + TTL};
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = {valid, select, KEY, TTL}; return; }
  const node = document.getElementById('pp-pdp-ab-config');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  const consentLink=[...document.links].find(link=>link.href.includes('GDPR_769769dd5c4da8efb4d18bf16ca2c677'));
  if(consentLink){consentLink.classList.add('iubenda-cs-preferences-link');consentLink.href='#';}
  const preview = document.documentElement.dataset.role === 'unpublished';
  const override = new URLSearchParams(location.search).get('pp_ab_qa');
  const qa = preview && /^[ABR]$/.test(override || '');
  let record = null;
  let attributed = false;
  let allowed = false;
  let current = 'A';
  let saved = null;
  let reviews = null;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function state(value) { node.dataset.state = value; node.dataset.variant = current; }
  function permitted() {
    try { return Shopify.customerPrivacy.analyticsProcessingAllowed() === true; } catch (_) { return false; }
  }
  function forget() {
    try { localStorage.removeItem(KEY + (qa ? '_qa' : '')); } catch (_) {}
    record = null;
    attributed = false;
  }
  function publish(name, data) {
    if (qa || !attributed || !permitted()) return;
    try { Shopify.analytics.publish(name, data); } catch (_) {}
  }
  async function annotate() {
    if (!record || !permitted()) return;
    const attributes = qa ? {pp_pdp_ab_qa:record.variant,pp_pdp_ab_qa_experiment:KEY,pp_pdp_ab_qa_assignment:record.id} : {pp_pdp_ab_experiment:KEY, pp_pdp_ab_variant:record.variant, pp_pdp_ab_assignment:record.id};
    const response = await fetch(root + 'cart/update.js', {method:'POST', signal:AbortSignal.timeout(1500), headers:{'Content-Type':'application/json'}, body:JSON.stringify({attributes})});
    if (!response.ok) throw new Error('Attribution unavailable');
    const cart = await response.json();
    if (!Object.entries(attributes).every(([key,value]) => cart.attributes[key] === value)) throw new Error('Attribution mismatch');
    attributed = true;
    state(qa ? 'qa-attributed' : 'attributed');
  }
  async function showB() {
    const main = document.getElementById('MainContent');
    if (!main || main.querySelector('.pp-pdp-shell')) { current = 'B'; return; }
    const url = new URL(location.href);
    url.searchParams.delete('view');
    url.searchParams.set('section_id','pp-pdp-editable');
    const response = await fetch(url, {signal:AbortSignal.timeout(5000)});
    if (!response.ok) throw new Error('PDP unavailable');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const shell = doc.querySelector('.pp-pdp-shell');
    const variantConfig = doc.querySelector('#pp-pdp-config');
    if (!shell || !shell.querySelector('#main-cta') || !variantConfig) throw new Error('PDP incomplete');
    const scripts = [...doc.querySelectorAll('script')].filter(s => s.type !== 'application/json' && s.type !== 'application/ld+json');
    const reviewNode = main.querySelector('#judgeme_product_reviews');
    if (reviewNode) {
      const anchor=document.createElement('span'); anchor.hidden=true; reviewNode.before(anchor);
      reviews={node:reviewNode,anchor:anchor};
    }
    const fragment = document.createDocumentFragment();
    while (main.firstChild) fragment.append(main.firstChild);
    saved = fragment;
    for (const script of scripts) script.remove();
    for (const child of [...doc.body.childNodes]) main.append(document.importNode(child,true));
    const reviewTarget=main.querySelector('#judgeme_product_reviews');
    if (reviewTarget && reviews) reviewTarget.replaceWith(reviews.node);
    for (const script of scripts) {
      const next = document.createElement('script');
      if (script.src) { if (!script.src.includes('/pp-pdp-editor.js')) continue; next.src = script.src; next.async = false; }
      else next.textContent = script.textContent;
      if (next.src) {
        await new Promise(function(resolve,reject) {
          const timeout=setTimeout(function(){next.remove();reject(new Error('PDP script timeout'));},5000);
          next.onload=function(){clearTimeout(timeout);resolve();};
          next.onerror=function(){clearTimeout(timeout);reject(new Error('PDP script unavailable'));};
          main.append(next);
        });
      } else main.append(next);
    }
    current = 'B';
    state(qa ? 'qa-rendered' : 'rendered');
  }
  function showA() {
    const main = document.getElementById('MainContent');
    if (saved && main) { if(reviews) reviews.anchor.replaceWith(reviews.node); main.replaceChildren(saved); saved = null; reviews=null; }
    current = 'A';
  }
  async function start() {
    allowed = permitted();
    node.dataset.analyticsAllowed = String(allowed);
    if (!config.enabled || !config.measurementReady) {
      if (!qa) { state('disabled'); return; }
    }
    if (window.Shopify.designMode || /bot|crawler|spider|lighthouse/i.test(navigator.userAgent)) { state('excluded'); return; }
    if (!allowed) {
      forget();
      if (qa && override === 'B') await showB();
      state('consent-denied');
      return;
    }
    try {
      const storageKey = KEY + (qa ? '_qa' : '');
      let prior=null;
      try { prior=JSON.parse(localStorage.getItem(storageKey) || 'null'); } catch (_) { localStorage.removeItem(storageKey); }
      const bytes = crypto.getRandomValues(new Uint32Array(1));
      record = select(prior, Date.now(), bytes[0] / 4294967296, crypto.randomUUID());
      if (qa && override !== 'R') record.variant = override;
      localStorage.setItem(storageKey, JSON.stringify(record));
      if (record.variant === 'B') await showB();
      else showA();
      await annotate();
      publish('pp_pdp_ab_exposure', {experiment:KEY, variant:record.variant, assignment_id:record.id});
      if(qa && permitted()) Shopify.analytics.publish('pp_pdp_ab_qa',{experiment:KEY,variant:record.variant,assignment_id:record.id,qa:true,stage:'exposure',test_run:crypto.randomUUID()});
    } catch (_) {
      showA(); forget(); state('fallback');
    }
  }
  window.ppPdpExperiment = {
    beforeAdd:async function () {
      if (!record || !permitted()) return;
      try { await annotate(); } catch (_) { attributed = false; state('attribution-failed'); }
    }
  };
  document.addEventListener('visitorConsentCollected', function () {
    node.dataset.analyticsAllowed = String(permitted());
    if (!permitted()) {
      forget();
      if (config.enabled || qa) fetch(root + 'cart/update.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({attributes:{pp_pdp_ab_experiment:'',pp_pdp_ab_variant:'',pp_pdp_ab_assignment:'',pp_pdp_ab_qa:'',pp_pdp_ab_qa_experiment:'',pp_pdp_ab_qa_assignment:''}})}).catch(function(){});
      state('consent-revoked');
    }
  });
  let attempts = 0;
  function ready() {
    if (window.Shopify.customerPrivacy) { start(); return; }
    if (++attempts < 100) setTimeout(ready,100);
    else state('privacy-unavailable');
  }
  if (window.Shopify.loadFeatures && !window.Shopify.customerPrivacy) Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], function() {});
  ready();
})();
